import { decimalInput } from './absenceFormValues';
import type { AbsenceTimeOffRequestCalculation } from './model';

type BalancePreviewCalculation = Partial<Pick<AbsenceTimeOffRequestCalculation, 'available' | 'quantity'>>;

/** 현재 선택과 일치하는 계산 결과만 전달한다. available에는 승인 대기량 차감이 이미 반영되어 있다. */
export function absenceRequestBalancePreview(calculation?: BalancePreviewCalculation): string | undefined {
  const available = finiteQuantity(calculation?.available);
  const quantity = finiteQuantity(calculation?.quantity);
  if (available === undefined || quantity === undefined) return undefined;
  const remaining = available - quantity;
  if (!Number.isFinite(remaining)) return undefined;
  return decimalInput(Number(remaining.toFixed(4)));
}

function finiteQuantity(value: string | undefined): number | undefined {
  if (!value?.trim()) return undefined;
  const quantity = Number(value);
  return Number.isFinite(quantity) ? quantity : undefined;
}
